const STORAGE_KEY = 'started-modules';

function readIds(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? new Set(JSON.parse(raw) as string[]) : new Set();
  } catch {
    return new Set();
  }
}

function writeIds(ids: Set<string>): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
}

export function getStartedModuleIds(): Set<string> {
  return readIds();
}

export function markModuleStarted(id: string): void {
  const ids = readIds();
  ids.add(id);
  writeIds(ids);
}

export function clearStartedModule(id: string): void {
  const ids = readIds();
  ids.delete(id);
  writeIds(ids);
}
